import _APIPaths from 'resources/apiPaths.json';
import {Map} from 'js/reusable/types/general';

const APIPaths = _APIPaths as Map<Map>;

const app           = import.meta.env.REACT_APP_BUILD_TARGET;
const env           = import.meta.env.REACT_APP_ENVIRONMENT;
const network       = env === 'prod' ? import.meta.env.REACT_APP_NETWORK : 'pn_fb';
const appPath       = app === 'admin' ? 'admin/' : 'user/';

const APIPath = env && network ? APIPaths[env][network] : null;

export const certPath           = `https://${APIPath}/cert-email`;

export const tokenPath          = `https://${APIPath}/auth/token/${network}/${appPath}`;

export const refreshTokenPath   = `https://${APIPath}/auth/refresh-token/${network}/${appPath}`;

export const logoutPath         = `https://${APIPath}/auth/logout/${network}/${appPath}`;

export const graphAPIPath       = `https://${APIPath}/graphql/${network}/`;

export const digestPath         = `https://${APIPath}/auth/public-token/${network}/`;

export const exchangeTokenPath   = `https://${APIPath}/auth/exchange-token/${network}/${appPath}`;

